import { useTranslation } from "react-i18next";

export const StepContactThanks = ({ returnUrl }: { returnUrl: string }) => {
	const { t } = useTranslation();

	return (
		<div className="row">
			<div className="col-md-12 col-sm-12 col-xs-12">
				<h2>{t("thanYouForContacting")}</h2>
				<p>
					<button type="submit" className="btn" onClick={() => (window.location.href = returnUrl)}>
						{t("returnToAsiakastieto")}
					</button>
				</p>
			</div>
		</div>
	);
};
